<template>
  <div>
    <v-row :class="`${ noPadding ? '' : 'px-9 pb-5' } warning-row`" :justify-content="'start'">
      <FontIcon class="warning-icon pa-2" :style="{color}">{{level ==='success' ? 'check' : 'report_problem' }}</FontIcon>
      <v-col class="warning-message pa-2" :class="{'pr-9': !!details}" :style="{color}">
        {{ message }}
        <template v-if="details">
          <FontIcon class="pa-2 toggle-details" :style="{color}" @click.native="toggleDetails">{{ showDetails ? "expand_less" : "expand_more" }}</FontIcon>
          <div class="details" v-show="showDetails">{{ details }}</div>
        </template>
        <slot>
        </slot>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import FontIcon from '@/components/FontIcon.vue';
import _colors from '@/helpers/colors';

@Component({
  components: {
    FontIcon
  }
})
export default class AlertRow extends Vue {
  @Prop({ type: [String], required: true })
  public message!: string;

  @Prop({ type: [String], required: false })
  public details: string | undefined;

  @Prop({ type: [String], required: false, default: 'warning' })
  public level!: string;

  @Prop({ default: () => false })
  public noPadding!: boolean;

  private showDetails: boolean = false;

  get color(): string {
    if (this.level === 'alarm') {
      return _colors['vv-red'];
    }
    if (this.level === 'success') {
      return _colors['vv-green'];
    }
    return _colors['warning-yellow'];
  }

  private toggleDetails() {
    this.showDetails = !this.showDetails;
  }
}
</script>
<style lang="stylus">
#app {
  .warning-row {

    .warning-icon {
      display: block;
    }

    .warning-message {
      position: relative;

      .toggle-details {
        position: absolute;
        top: 0;
        right: 0;
      }

      .details {
        font-style: italic;
        font-weight: 300;
      }

    }
  }
}
</style>
